import { render, staticRenderFns } from "./sql-query.vue?vue&type=template&id=216b53d3&scoped=true&"
import script from "./sql-query.vue?vue&type=script&lang=js&"
export * from "./sql-query.vue?vue&type=script&lang=js&"
import style0 from "./sql-query.vue?vue&type=style&index=0&id=216b53d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216b53d3",
  null
  
)

export default component.exports